import { useState } from "react"
import PatientSidebar from "../../components/dashboard/PatientSidebar"
import LogoSection from "../../components/ui/LogoSection"

export default function QRCodeError({
  patientName = "Patient Name",
  studyName = "Atopic Eczema",
  onSignOut = () => {},
}) {
  const [showSidebar, setShowSidebar] = useState(false)

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }

  return (
    <div className="flex h-screen relative">
      {/* Mobile menu button */}
      <button onClick={toggleSidebar} className="md:hidden fixed top-4 left-4 z-50 bg-white p-2 rounded-md shadow-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Sidebar - hidden on mobile by default, shown when toggled */}
      <div className={`${showSidebar ? "block" : "hidden"} md:block fixed md:relative z-40 h-full`}>
      <PatientSidebar patientName={patientName} onSignOut={onSignOut} showSignature={false} showQRCode={true} />
      </div>

      {/* Overlay to close sidebar on mobile */}
      {showSidebar && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setShowSidebar(false)}
        ></div>
      )}

      <div className="flex-1 overflow-auto bg-dashboard-bg">
        <div className="p-4 flex justify-between items-center">
          <div className="font-bold mt-2 text-xl ml-8 md:ml-0">Access unavailable</div>
        </div>

        <main className="p-4 md:p-6">
          <div className="bg-dashboard-bg1 p-4 md:p-6 rounded-xl">
            <h2 className="text-xl font-semibold mb-6">Access to the QR code is no longer available</h2>

            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="w-full md:w-1/2 md:mb-0 relative">
                <div className="relative">
                  <img
                    src="/img/QR code error.png"
                    alt="QR Code Error"
                    className="max-w-full h-auto mx-auto"
                    style={{ maxHeight: "500px" }}
                  />

                  {/* Text */}
                  <div className="absolute bottom-20 left-20 right-0 p-4">
                    <h3 className="font-medium mb-2">Why am I seeing this?</h3>
                    <ul className="space-y-2 list-disc pl-5">
                      <li>You have withdrawn your consent</li>
                      <li>The clinical study you were part of has ended</li>
                      <li>This QR code or link is no longer valid</li>
                    </ul>
                  </div>
                  <div className="h-10"></div>
                    <div className="h-10"></div>
                    <div className="h-10"></div>
                    <div className="h-10"></div>
                </div>
              </div>

              <div className="w-full md:w-1/2 flex justify-center">
                <LogoSection titleColor="text-linkColor" />
              </div>
              
              
            </div>
          </div>
          
        </main>
        
      </div>
    </div>
  )
}
